/*
 * @Author: bobo 350910378@qq.com
 * @Date: 2023-11-09 20:16:42
 * @LastEditors: bobo 350910378@qq.com
 * @LastEditTime: 2024-03-28 21:05:03
 * @FilePath: \baishu_react_ui\src\utils\RelyProcessor_3_0.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */

import { BsyConfig } from '../global/BsyConfig';
import { BsyFormula } from '../global/Formula';
import { BsyUtils } from './Utils';

import _ from 'lodash';

export default class RelyProcessor_3_0 {

    constructor(opt, labelMap) {
        this.labelMap = {
            ...labelMap
        };
        window.openRelylog = true;

        _._isSubformWidget = _._isSubformWidget || BsyUtils._isSubformWidget;
        _.isObjectEmpty = _.isObjectEmpty || BsyUtils.isObjectEmpty;
        this.formId = opt.formId;
        var n = opt.items
            , r = opt.formEvents
            , a = opt.asyncLimit
            , o = void 0 === a ? 3 : a;
        this.formRely = opt.formRely;
        this.defaultVersion = 0;
        this.version = 0;
        this.asyncLimit = o
        this.versionMap = {};
        this.stateMap = {};
        this.asyncMap = {};
        this.defaults = [];
        this.requestMergeMap = {};
        this.subFieldsMap = {};
        this.buttonMap = {};
        this.relyMap = this.getRelyWidgetsMap(n);
        this.linkMap = this.getLinkMap(this.relyMap);
        this.requestFieldsMap = this.getRequestFieldsMap();
        this.eventMap = {};
        this.blockMap = {};
        this.excludeMap = {};
        this.mapFormEvents(r);
        this.asyncConcurrentQue = [];
        this.asyncTodoQue = [];
        this.errorMap = {};


        this.moduelFormSouceMap = this._getFormSourceMap(n);



        this.map2text();

    }

    _getFormSourceMap = (a) => {
        var c = {};
        BsyUtils.forEach(a, function (a, d) {

            if (d.widget.type == "formsource") {
                c[d.widget.widgetName] = [];
            } else {
                if (d.widget.hasOwnProperty("formsource") || d.widget.hasOwnProperty("linkformsource") || d.widget.hasOwnProperty("right_formsource") || d.widget.hasOwnProperty("left_formsource")) {
                    if (!c.hasOwnProperty(d.widget.formsource)) {
                        c[d.widget.formsource] = [];
                    }
                    if (!c.hasOwnProperty(d.widget.linkformsource)) {
                        c[d.widget.linkformsource] = [];
                    }
                    if (!c.hasOwnProperty(d.widget.right_formsource)) {
                        c[d.widget.right_formsource] = [];
                    }
                    if (!c.hasOwnProperty(d.widget.left_formsource)) {
                        c[d.widget.left_formsource] = [];
                    }
                    if (d.widget.formsource)
                        c[d.widget.formsource].push(d.widget.widgetName);
                    if (d.widget.linkformsource)
                        c[d.widget.linkformsource].push(d.widget.widgetName);
                    if (d.widget.left_formsource)
                        c[d.widget.left_formsource].push(d.widget.widgetName);
                    if (d.widget.right_formsource)
                        c[d.widget.right_formsource].push(d.widget.widgetName);
                }
            }
        });
        return c;
    }

    map2text = () => {

        let _this = this;
        //#
        let relyMapText = {};
        _.forEach(this.relyMap, function (b1, a1) {
            let arr = [];
            _.forEach(b1, function (b2, a2) {
                arr.push(_this.labelMap[b2])
            })
            relyMapText[_this.labelMap[a1]] = arr
        })
        let linkMaptext = {};
        _.forEach(this.linkMap, function (b1, a1) {
            let arr = [];
            _.forEach(b1, function (b2, a2) {
                arr.push(_this.labelMap[b2])
            })
            linkMaptext[_this.labelMap[a1]] = arr
        })
        // console.log(this.relyMap)
        // console.log(this.linkMap)
        // console.log(relyMapText)
        // console.log(linkMaptext)
        // console.log(this.labelMap)
    }

    getRequestFieldsMap = function () {
        let e = this
            , t = {};
        _.forEach(this.requestMergeMap, function (n1) {
            if (_.size(n1) > 1) {
                var r = []
                    , a = [];
                _.forEach(n1, (function (n) {
                    var i = n.field
                        , o = n.name
                        , l = {
                            field: i
                        };
                    e.subFieldsMap[o] && (l.subFields = e.subFieldsMap[o]);
                    r.push(l);
                    a.push(o);
                    t[o] = {
                        widgets: a,
                        fields: r
                    }
                }
                ))
            }
        })
        return t
    }

    mapFormEvents = (e) => {
        var t = this;
        _.forEach(e, function (e, i) {
            if (e.enabled) {
                var n = t.getEventNodeId(e);
                t.eventMap[n] = e;
                t.relyMap[n] = [e.trigger];
                t.linkMap[e.trigger] || (t.linkMap[e.trigger] = []);
                t.linkMap[e.trigger].push(n);
                var r = _._isSubformWidget(e.trigger);
                if (r && !t.buttonMap[e.trigger]) {
                    var a = e.trigger.split(".")[0];
                    t.linkMap[a] || (t.linkMap[a] = []);
                    t.linkMap[a].push(n);
                    t.linkMap[a] = _.uniq(t.linkMap[a])
                }
                _.forEach(e.action, function (e, i) {

                    if (e.field) {
                        t.relyMap[e.field] = [n];
                        !r && _._isSubformWidget(e.field) && t.relyMap[e.field].push(e.field.split(".")[0]);
                        t.linkMap[n] || (t.linkMap[n] = []);
                        t.linkMap[n].push(e.field);
                    }
                    // e.field && (t.relyMap[e.field] = [n],
                    // !r && _._isSubformWidget(e.field) && t.relyMap[e.field].push(e.field.split(".")[0]),
                    // t.linkMap[n] || (t.linkMap[n] = []),
                    // t.linkMap[n].push(e.field))
                })
            }
        })
    }

    getEventNodeId = (e) => {
        return "event_" + e.id
    }

    isEventNode = (e) => {
        return e.indexOf("event_") > -1
    }
    getEventById = (e) => {
        return "event_" + e.id
    }

    getBlockEvents = () => {
        var t = this
            , n = [];
        // _.forEach(this.blockMap, function (a, r) {
        //     var i = t.getEventById(a);
        //     if (i) {
        //         var o = (i.request_rely || []).concat(i.action_rely);
        //         _.isObjectEmpty(o) || (0, I.cq5)(o, e) > -1 && _.forEach(r, (function (e) {
        //             _.isNil(e) ? n.push(a) : n.push(D(a, e))
        //         }
        //         ))
        //     }
        // })
        return n
    }

    checkEventRely = function (e, t) {
        var n = this
            , r = this.getEventById(e);
        if (!r)
            return !0;
        var a = (r.request_rely || []).concat(r.action_rely)
            , i = !0;
        _.forEach(a, function (e, i) {
            var r = n.getVersion(e, t);
            if (r)
                return r !== n.getAsync(e, t) ? (i = !1,
                    !1) : void 0
        })
        return i
    }

    getLinkMap = function (e) {
        var t = this
            , n = {};
        _.forEach(e, function (e, r) {
            _.forEach(e, function (e, i) {
                t.add2LinkMap(n, e, r)
            })
        })
        return n
    }

    add2LinkMap = function (a, b, c) {
        a[b] || (a[b] = []);
        a[b].push(c);
        if (/\./.test(b) && !/\./.test(c)) {
            let d = b.split(".")[0];
            this.add2LinkMap(a, d, c)
        }
        return a
    }

    K = function (e) {

    }

    H = function (e) {

        if (!e)
            return [];

        var t = [];
        _.forEach(e.widgets, function (e) {
            e && t.push(e)
        })
        return t

    }

    md5 = (data) => {
        // const crypto = require('crypto');
        // const userInputPassword = 'data'
        return BsyFormula.MD5(JSON.stringify(data))
    }

    D = function (e, t) {
        return [e, t].join("#")
    }

    getRelyWidgetsMap = function (e, t) {
        var n = this
            , a = {};
        _.forEach(e, (function (e) {
            var i = e.widget;
            if (i && !n.qf4(i.type) && !n.E(i.type)) {
                if ("button" === i.type && (n.buttonMap[t ? [t, i.widgetName].join(".") : i.widgetName] = !0),
                    "subform" === i.type) {
                    var o = n.getRelyWidgetsMap(i.items, i.widgetName);
                    _.forEach(o, (function (e, t) {
                        var n = [i.widgetName, t].join(".");
                        e.length && e.push(i.widgetName)
                        _.merge(a, { [n]: _.uniq(e) })
                    }
                    ))
                }
                if ("location" === i.type && i.limitWidget)
                    _.merge(a, { [i.widgetName]: [].concat(i.limitWidget) });
                else {
                    var l = i.rely
                        , u = n.H(l);
                    if (l && !_.isObjectEmpty(u)) {
                        if (l.data) {
                            var c = n.md5({
                                filter: l.filter,
                                formId: l.data.formId,
                                refAppId: l.data.refAppId
                            })
                                , s = {
                                    field: l.data.field,
                                    name: t ? [t, i.widgetName].join(".") : i.widgetName
                                };
                            _.has(n.requestMergeMap, c) ? n.requestMergeMap[c].push(s) : n.requestMergeMap[c] = [s];

                            if (l.data.subformField) {
                                n.subFieldsMap[i.widgetName] = _.map(l.data.subformField, (function (e) {
                                    return e.link
                                }
                                ))
                                // console.log(`l.data.subformField ${n.labelMap[i.widgetName]} ${JSON.stringify(n.subFieldsMap[i.widgetName])}`)
                            }
                            // l.data.subformField && (n.subFieldsMap[i.widgetName] = _.map(l.data.subformField, (function (e) {
                            //     return e.link
                            // }
                            // )))
                            //兼容最老的 子表单的联动设置
                            if (l.data.joinfield) {
                                let formId = n.formId;
                                l.data.subformField = [];
                                n.subFieldsMap[i.widgetName] = _.map(l.data.joinfield, (function (e) {

                                    var obj = {
                                        link: null,
                                        name: null,
                                    }
                                    BsyUtils.forEach(e, function (index, val) {
                                        if (index.indexOf(formId) == -1) {
                                            obj.link = val;
                                        } else {
                                            obj.name = val;
                                        }
                                    })
                                    l.data.subformField.push(obj);
                                    return obj.link
                                }
                                ))
                                // console.log(`.data.joinfield ${n.labelMap[i.widgetName]} ${JSON.stringify(n.subFieldsMap[i.widgetName])}`)
                            }


                            // l.subLink && (n.subFieldsMap[i.widgetName] = _.map(l.subLink, (function (e) {
                            //     return e.link
                            // }
                            // )))
                        }
                        _.merge(a, { [i.widgetName]: u })
                    }
                }
            }
        }
        ))
        return a
    }

    // getRelyWidgetsMap = function (e, t) {
    //     var n = this
    //         , a = {};
    //     _.forEach(e, function (e) {
    //         var i = e.widget;
    //         if (i && !('linkdata' === i.type) && !('linkdata' === i.type)) {
    //             "button" === i.type && (n.buttonMap[t ? [t, i.widgetName].join(".") : i.widgetName] = !0)
    //             if ("subform" === i.type) {
    //                 var o = n.getRelyWidgetsMap(i.items, i.widgetName);
    //                 _.forEach(o, function (e, t) {
    //                     var n = [i.widgetName, t].join(".");
    //                     e.length && e.push(i.widgetName)
    //                     a = { ...a, [n]: _.uniq(e) }
    //                 })
    //             }
    //             if ("location" === i.type && i.limitWidget) {
    //                 a = { ...a, [i.widgetName]: [].concat(i.limitWidget) }
    //                 // (0,
    //                 //     I.f0i)(a, (0,
    //                 //         r.Z)({}, i.widgetName, [].concat(i.limitWidget)));
    //             } else {
    //                 var l = i.rely
    //                     , u = n.H(l);
    //                 if (l && !_.isObjectEmpty(u)) {
    //                     if (l.data) {
    //                         var c = n.md5({
    //                             filter: l.filter,
    //                             formId: l.data.formId,
    //                             refAppId: l.data.refAppId
    //                         })
    //                         var s = {
    //                             field: l.data.field,
    //                             name: t ? [t, i.widgetName].join(".") : i.widgetName
    //                         };

    //                         if (n.requestMergeMap.hasOwnProperty(c)) {
    //                             n.requestMergeMap[c].push(s);
    //                         } else {
    //                             n.requestMergeMap[c] = [s];
    //                         }

    //                         if (l.subLink) {
    //                             n.subFieldsMap[i.widgetName] = l.subLink.map(e => { return e.link })

    //                             // _.map(l.subLink, (function (e) {
    //                             //     return e.link
    //                             // }
    //                             // ))
    //                         }

    //                         // l.subLink && (n.subFieldsMap[i.widgetName] = (0,
    //                         //     I.UID)(l.subLink, (function (e) {
    //                         //         return e.link
    //                         //     }
    //                         //     )))

    //                         // (0, I.e$l)(n.requestMergeMap, c) ? n.requestMergeMap[c].push(s) : n.requestMergeMap[c] = [s],
    //                         // l.subLink && (n.subFieldsMap[i.widgetName] = (0,
    //                         //     I.UID)(l.subLink, (function (e) {
    //                         //         return e.link
    //                         //     }
    //                         //     )))
    //                     }

    //                     a = { ...a, [i.widgetName]: u }
    //                     // (0,
    //                     //     I.f0i)(a, (0,
    //                     //         r.Z)({}, i.widgetName, u))
    //                 }
    //             }
    //         }
    //     })
    //     return a
    // }

    getVersion = function (e, t) {
        var n = this.versionMap[e] || this.defaultVersion;
        _.isNil(t) || !_._isSubformWidget(e) && !this.isEventNode(e) || (n = Math.max(n, this.versionMap[this.D(e, t)] || this.defaultVersion))
        // window.openRelylog && console.log(`getVersion ${n}`);
        return n
    }

    getState = function (e, t) {
        var n = this.stateMap[e] || this.defaultVersion;
        _.isNil(t) || !_._isSubformWidget(e) && !this.isEventNode(e) || (n = Math.max(n, this.stateMap[this.D(e, t)] || this.defaultVersion));
        // console.log(`getState ${e},${t} ret:${n}`)
        return n
    }

    getAsync = function (e, t) {
        if (_.isNil(t) || !_._isSubformWidget(e) && !this.isEventNode(e))
            return this.asyncMap[e];
        var n = this.asyncMap[this.D(e, t)];
        var n1 = !1 === n ? n : Math.max(this.asyncMap[e] || this.defaultVersion, n || this.defaultVersion)
        // console.log(`getAsync ${e},${t} ret:${n1}`)
        return n1;
    }

    fireNextRely = function (e, t, n, r) {
        var a = this;
        this.setAsyncMap(n, e, r);
        var i = this.linkMap[n];
        _.forEach(i, function (n) {
            if (!(e < a.getState(n, r)) && a.checkRely(t, e, n, r)) {
                var i = t.getField(n, r);
                if (i) {
                    var o = Math.max(e, a.getVersion(n, r));
                    a.setAsyncMap(n, !1, r);
                    a.startRely(t, n, i, o);
                } else
                    a.fireNextRely(e, t, n, r)
            }
        })
    }

    getRelyVersion = function (e, t, n) {
        var r = this
            , a = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {}
            , i = arguments.length > 4 ? arguments[4] : void 0
            , o = arguments.length > 5 ? arguments[5] : void 0
            , l = this.isEventNode(t);
        _._isSubformWidget(t) || l || (o = void 0);
        _.forEach(e[t], (function (u) {
            if (!(a[u] || a[r.D(u, o)] || i && _._isSubformWidget(u) && u.split(".")[0] === t)) {
                if (i && r.isEventNode(u)) {
                    var c = r.getEventById(u);
                    if (_._isSubformWidget(c.trigger) && c.trigger.split(".")[0] === t)
                        return
                }
                if (l && _._isSubformWidget(u)) {
                    var s = r.getEventById(t);
                    if (s && !_._isSubformWidget(s.trigger)) {
                        var d = u.split(".")[0];
                        a[d] = n;
                        r.getRelyVersion(e, d, n, a, !1, o)
                    }
                }
                _.isNil(o) || !_._isSubformWidget(u) && !r.isEventNode(u) ? a[u] = n : a[r.D(u, o)] = n;
                r.getRelyVersion(e, u, n, a, !1, o)
            }
        }
        ))
        return a
    }

    isAsyncCalculating = function () {
        return !_.isObjectEmpty(this.asyncConcurrentQue.concat(this.asyncTodoQue))
    }

    A = function (e) {
        return /#/.test(e)
    }

    //检查字段是否存在，不存在了就不用验证了
    checkField = (o) => {
        let widget = '';
        let row = "";
        if (this.A(o)) {
            var o1 = _.split(o, "#");
            widget = o1[0];
            row = o1[1]
        } else {
            widget = o;
        }
        if (this.formRely.getField(widget, row)) {
            return true
        }
        return false;
    }

    checkAsyncState = function (e, t) {
        var n, r = this, i = true;

        _.forEach(this.asyncMap, function (a, o) {

            if (!r.checkField(o)) {
                return
            }

            if ((!e || r.isEventNode(o)) && (!t || !r.isEventNode(o))) {
                if (i === false) {
                    n = o;
                    return false;
                } else {
                    i = a !== false;
                    if (i === false) {
                        n = o;
                        return false;
                    }
                }
            }
        });

        if (i) {
            this.errorField = void 0;
        } else if (!this.isAsyncCalculating() && n) {
            if (r.A(n)) {
                var o = _.split(n, "#"),
                    l = o,
                    u = l[0],
                    c = l[1];

                this.errorField = {
                    path: u,
                    row: c
                };
            } else {
                this.errorField = {
                    path: n
                };
            }
        }

        return i;
    }

    // checkAsyncState = function (e, t) {
    //     var n, r = this, i = !0;
    //     _.forEach(this.asyncMap, function (a, o) {
    //         if ((!e || r.isEventNode(o)) && (!t || !r.isEventNode(o)))
    //             return (i = !1 !== a) ? void 0 : (n = o,
    //                 !1)
    //     })
    //     if (i)
    //         this.errorField = void 0;
    //     else if (!this.isAsyncCalculating() && n)
    //         if (r.A(n)) {
    //             var o = _.split(n, "#")
    //                 , l = _.split(o, 0, 2)
    //                 , u = l[0]
    //                 , c = l[1];
    //             this.errorField = {
    //                 path: u,
    //                 row: c
    //             }
    //         } else
    //             this.errorField = {
    //                 path: n
    //             };
    //     return i
    // }

    setVersionMap = function (e, t, n) {
        _.isNil(n) || !_._isSubformWidget(e) && !this.isEventNode(e) ? this.versionMap[e] = t : this.versionMap[this.D(e, n)] = t
    }

    isWidgetExclude = function (e, t, n) {
        var r = _.isNil(n) || !_._isSubformWidget(e) && !this.isEventNode(e) ? e : this.D(e, n);
        return _.get(this.excludeMap, r) === t
    }
    setExcludeMap = function (e, t, n) {
        _.isNil(n) || !_._isSubformWidget(e) && !this.isEventNode(e) ? this.excludeMap[e] = t : this.excludeMap[this.D(e, n)] = t
    }
    setStateMap = function (e, t, n) {
        _.isNil(n) || !_._isSubformWidget(e) && !this.isEventNode(e) ? this.stateMap[e] = t : this.stateMap[this.D(e, n)] = t
    }

    setAsyncMap = function (e, t, n) {
        _.isNil(n) || !_._isSubformWidget(e) && !this.isEventNode(e) ? this.asyncMap[e] = t : this.asyncMap[this.D(e, n)] = t
    }

    addDefaultRely = function (e, t) {
        // console.log('addDefaultRely', e, t);
        !t && _.isObjectEmpty(e.value) && _.isObjectEmpty(e.widget.value) || this.defaults.push(e)
    }
    getDefaultRely = function () {
        return this.defaults
    }
    setErrorMap = function (e, t, n) {
        this.errorMap.hasOwnProperty(t) && e && delete this.errorMap[t]
        e || (this.errorMap[t] = n)
    }
    getErrorMap = function () {
        return this.errorMap
    }

    checkRely = function (e, t, n, r) {
        var a = this
            , i = !0;
        var widgetLabel1 = a.labelMap[n] || n;
        var label = a.labelMap[n];
        var rdx = '';
        if (r) {
            var field = e.getField(n, r)
            rdx = field.rowIdx;
        }
        window.openRelylog && console.log(`checkRely ${widgetLabel1} ${n} ------------------ _checkRely start ------------------ \n`);
        // console.log(`checkRely ${JSON.stringify(this.relyMap[n])}\n`);
        _.forEach(this.relyMap[n], function (o) {

            var widgetLabel = a.labelMap[o] || o
            window.openRelylog && console.log(`checkRely ${widgetLabel1}->${widgetLabel} ${o} \n`);
            if (_._isSubformWidget(o) && !_._isSubformWidget(n)) {
                var l = o.split(".")[0];
                t === a.getVersion(l, r) && (i = a.getAsync(l, r) === t)
                var fields = e.getFields(o)
                _.forEach(fields, function (e) {
                    // if (e) {
                    //     var n = e.rowId;
                    //     if (t === a.getVersion(o, n)) {
                    //         if (a.getAsync(o, n) !== t)
                    //             return i = !1,
                    //                 !1
                    //     } else if (a.getVersion(o, n)) {
                    //         if (!(Number(a.getAsync(o, n)) >= a.getVersion(o, n)))
                    //             return i = !1,
                    //                 !1;
                    //         i = !0
                    //     }
                    // }
                    if (e) {
                        var n = e.rowId;
                        if (t === a.getVersion(o, n)) {
                            if (a.getAsync(o, n) !== t) {
                                i = !1
                                return !1
                            }

                        } else if (a.getVersion(o, n)) {
                            // 2024 03 29 公式没有完整执行的逻辑，需要观察实际情况
                            // if (!(Number(a.getAsync(o, n)) >= a.getVersion(o, n))) {
                            //     i = !1;
                            //     return !1;
                            // }
                            i = !0
                        }
                    }
                })
            } else {
                var label = a.labelMap[o];

                // if (!1 === a.getAsync(o, r)) {
                //     i = !1;
                //     if(!i) {
                //         var label = a.labelMap[o];
                //         window.openRelylog && console.log(`checkRely fail 1 ${label} 失败，字段正在执行中`);
                //     }
                // } else if (t === a.getVersion(o, r)) {
                //     i = a.getAsync(o, r) === t;
                //     if(!i) {
                //         var label = a.labelMap[o];
                //         window.openRelylog && console.log(`checkRely fail 2 ${label} 失败，字段version与当前version一致，但version与async不一致，当前version字段还未执行过，需要等待一会`);
                //     }
                // } else if (a.getVersion(o, r)) {
                //     var label = a.labelMap[o];
                //     i = Number(a.getAsync(o, r)) >= a.getVersion(o, r);
                //     if(!i) {
                //         window.openRelylog && console.log(`checkRely fail 3 ${label} 失败，字段version已更新，但是async未执行`);
                //     }
                // }

                if (!1 === a.getAsync(o, r)) {
                    i = !1;
                    window.openRelylog && console.log(`checkRely fail 1 ${label} 失败，字段正在执行中`);
                } else if (t === a.getVersion(o, r)) {
                    let a1 = a.getAsync(o, r);
                    i = a1 === t;
                    if (!i) {
                        window.openRelylog && console.log(`checkRely fail 2 ${label} 失败，字段version与当前version一致，但version与async不一致，当前version字段还未执行过，需要等待一会`);
                    }
                } else {
                    // 2024 03 29 公式没有完整执行的逻辑，需要观察实际情况
                    // if (a.getVersion(o, r)) {
                    //     let a1 = Number(a.getAsync(o, r));
                    //     let a2 = a.getVersion(o, r);
                    //     i = a1 >= a2;
                    //     if (!i) {
                    //         window.openRelylog && console.log(`checkRely fail 3 ${label} 失败，字段version已更新，但是async未执行`);
                    //     }
                    // }
                }

                // !1 === a.getAsync(o, r) ?
                //     i = !1 :
                //     t === a.getVersion(o, r) ?
                //         i = a.getAsync(o, r) === t :
                //         a.getVersion(o, r) && (i = Number(a.getAsync(o, r)) >= a.getVersion(o, r));
            }
            if (!i) {
                return !1
            }

        })
        if (i) {


            if (this.getState(n, r) === t) {
                window.openRelylog && console.log(`checkRely ${label}已被赋值 失败`,
                    'subform:' + rdx,
                    'version:' + t);
                i = !1;
            } else {

                console.log('setStateMap', label, 'subform:' + rdx, 'version:' + t);
                this.setStateMap(n, t, r);
            }
        }
        // if (i) {
        //     this.getState(n, r) === t ?
        //         i = !1 :
        //         this.setStateMap(n, t, r)
        // }

        // i && (this.getState(n, r) === t ? i = !1 : this.setStateMap(n, t, r))
        return i
    }
    fireDefaultRely = function (e, t, n) {
        var r = this;
        this.version++;
        var a = this.version;


        if (this.formRely.form.options.eventType == "popupform") {
            // 弹出表单 与普通表单要区分处理
            // 2024-01-22 按钮弹出表单默认值触发按钮机制
            let defaults = [];
            let relyDefaults = [];
            let relyDefaultsValue = {};
            _.forEach(t, function (e) {
                if (BsyUtils.isObjectEmpty(e.rely)) {
                    defaults.push(e)
                } else {
                    relyDefaultsValue[[e.path, e.rowIdx].join('#')] = e.getValue();
                    relyDefaults.push(e);
                }
            })

            _.forEach(defaults, function (e) {
                _.merge(r.versionMap, r.getRelyVersion(r.linkMap, e.path, a, {}, !1, n))
            })
            _.forEach(defaults, function (t) {
                r.fireRely(t, a, e)
            })

            let hd = setInterval(e => {

                if (r.checkAsyncState(true)) {
                    if (r.checkAsyncState(false, true)) {
                        clearInterval(hd)
                        hd = null;
                        _.forEach(relyDefaults, function (t) {
                            t.setValue(relyDefaultsValue[[t.path, t.rowIdx].join('#')]);
                            r.formRely.fireWidgetRelyEvent(t, null);
                        })
                        return true;
                    } else {
                        return false;
                    }
                } else {

                    return false;
                }
            }, 50)
        } else {
            _.forEach(t, function (e) {
                _.merge(r.versionMap, r.getRelyVersion(r.linkMap, e.path, a, {}, !1, n))
            })
            _.forEach(t, function (t) {
                r.fireRely(t, a, e)
            })
        }

    }

    fireRely = function (e, t, n) {
        var r, a = this, i = e.path;
        _.isNil(e.rowId) || (r = e.rowId);
        var o = this.linkMap[i] || []
            , l = _.uniq(o.concat(this.getBlockEvents(i)));
        if (t) {
            this.finishRely(e, i, r);
            t = Math.max(t, this.getVersion(i, r));
        } else if (this.version++,
            t = this.version,
            this.setVersionMap(i, t, r),
            _.merge(this.versionMap, this.getRelyVersion(this.linkMap, i, t, {}, !0, r)),
            this.setStateMap(i, t, r),
            this.checkAsyncQue(),
            "subform" === e.type) {
            var u = [];
            _.forEach(l, function (e) {
                if (a.isEventNode(e)) {
                    var t = a.getEventById(e);
                    if (_._isSubformWidget(t.trigger) && t.trigger.split(".")[0] === i)
                        return
                }
                _._isSubformWidget(e) && e.split(".")[0] === i || u.push(e)
            })
            l = u
        }
        var lable = n.labelMap[i];
        console.log(`fireRely ${lable}`)
        this.setAsyncMap(i, t, r);
        _.forEach(l, function (e) {
            a.isEventNode(e) ? a.dealEventNodeLink(t, e, n, r) : a.dealFieldNodeLink(t, e, n, r)
        })
    }

    dealEventNodeLink = function (e, t, n, r) {
        var a = this;
        if (this.A(t)) {
            var i = t.split("#");
            t = i[0]
            r = i[1]
        }
        var o = this.getEventById(t);
        if (_.isNil(r) && _._isSubformWidget(o.trigger)) {
            var l = n.getFields(o.trigger);
            _.isObjectEmpty(l) ? this.fireNextRely(e, n, t, r) : _.forEach(l, function (r) {
                r && a.fireFormEvent(e, t, n, r.rowId)
            })
        } else
            this.fireFormEvent(e, t, n, r)
    }

    fireFormEvent = function (e, t, n, r) {
        if (!(e < this.getState(t, r)))
            if (this.checkEventRely(t, r)) {
                if (this.blockMap[t]) {
                    var a = _.indexOf(this.blockMap[t], r);
                    if (a > -1) {
                        this.blockMap[t].splice(a, 1);
                        _.isObjectEmpty(this.blockMap[t]) && delete this.blockMap[t]
                    }

                    // a > -1 && (this.blockMap[t].splice(a, 1), _.isObjectEmpty(this.blockMap[t]) && delete this.blockMap[t])
                }
                if (e = Math.max(e, this.getVersion(t, r)),
                    this.getState(t, r) === e)
                    return;
                this.setStateMap(t, e, r);
                this.setAsyncMap(t, !1, r);
                this.startFormEvent(e, t, n, r)
            } else {
                var i = this.blockMap[t] || [];
                this.blockMap[t] = _.uniq(i.concat(r))
            }
    }

    startFormEvent = function (e, t, n, r) {
        var a = {
            type: "event",
            form: n,
            widgetName: t,
            version: e,
            row: r
        };
        if (this.asyncConcurrentQue.length < this.asyncLimit) {
            this.updateAsyncQueen(a);
            n.dealFormEvent(t, this.getEventById(t), e, r);
        } else {
            this.asyncTodoQue.push(a)
        }

        // this.asyncConcurrentQue.length < this.asyncLimit ? (this.updateAsyncQueen(a),
        //     n.dealFormEvent(t, this.getEventById(t), e, r)) : this.asyncTodoQue.push(a)
    }

    dealFieldNodeLink = function (e, t, n, r) {
        var a, i = this;
        var widgetName = t;
        var lable = n.labelMap[t];
        if (r) {
            var field = n.getField(t, r)
            lable = [lable, 'subform:' + field.rowIdx].join('.')
        }
        window.openRelylog && console.log(`dealFieldNodeLink 1 ${lable} ${e}`)
        if (!(e < this.getState(t, r)))
            if (_._isSubformWidget(t) && _.isNil(r)) {
                var o = n.getFields(t);
                if (_.isObjectEmpty(o)) {
                    window.openRelylog && console.log(`dealFieldNodeLink 2 ${lable} ${t}`)
                    if (!this.checkRely(n, e, t)) {
                        window.openRelylog && console.log(`dealFieldNodeLink 3 失败 ${lable} ${t} `)
                        // window.openRelylog && console.log('versionMap', JSON.stringify(i.versionMap));
                        // window.openRelylog && console.log('stateMap', JSON.stringify(i.stateMap));
                        // window.openRelylog && console.log('asyncMap', JSON.stringify(i.asyncMap));
                        return;
                    }
                    window.openRelylog && console.log(`dealFieldNodeLink 4 next ${lable}`)
                    this.fireNextRely(e, n, t)
                } else
                    _.forEach(o, (function (r) {
                        if (r) {
                            var a = r.rowId;
                            window.openRelylog && console.log(`dealFieldNodeLink 2 ${lable} ${a} ${t}`)
                            if (!i.checkRely(n, e, t, a)) {
                                window.openRelylog && console.log(`dealFieldNodeLink 3 checkRely 失败 ${lable} ${a} ${t}`)
                                // window.openRelylog && console.log('versionMap', JSON.stringify(i.versionMap));
                                // window.openRelylog && console.log('stateMap', JSON.stringify(i.stateMap));
                                // window.openRelylog && console.log('asyncMap', JSON.stringify(i.asyncMap));
                                return;
                            }
                            window.openRelylog && console.log(`dealFieldNodeLink 4 startRely ${lable} ${a} ${t}`)
                            var o = Math.max(e, i.getVersion(t, a));
                            i.setAsyncMap(t, !1, a);
                            i.startRely(n, t, r, o, a)
                        }
                    }
                    ))
            } else {
                if (!this.checkRely(n, e, t, r)) {
                    window.openRelylog && console.log(`dealFieldNodeLink 31 checkRely 失败 ${lable} ${t}`)
                    // window.openRelylog && console.log('versionMap', JSON.stringify(i.versionMap));
                    // window.openRelylog && console.log('stateMap', JSON.stringify(i.stateMap));
                    // window.openRelylog && console.log('asyncMap', JSON.stringify(i.asyncMap));
                    return;
                }

                if (!(a = n.getField(t, r)))
                    return void this.fireNextRely(e, n, t, r);
                var l = Math.max(e, this.getVersion(t, r));
                window.openRelylog && console.log(`dealFieldNodeLink 41 ${lable} ${t}`)
                this.setAsyncMap(t, !1, r);
                this.startRely(n, t, a, l, r)
            }
    }

    fireOCR = function (e, t, n) {
        var r = this;
        this.version++;
        var a = this.version
            , i = e.getOcrLinkWidgets(t.type);
        if (!_.isObjectEmpty(i)) {
            _.forEach(i, function (e) {
                r.setVersionMap(e, a)
                if (/\./.test(e)) {
                    var t = e.split(".")[0];
                    r.setVersionMap(t, a);
                    r.setStateMap(t, a);
                    r.setAsyncMap(t, !1);
                    var n = r.linkMap[t] || [];
                    _.forEach(n, function (e) {
                        r.setVersionMap(e, a)
                    })
                }
                _.merge(r.versionMap, r.getRelyVersion(r.linkMap, e, a, {}, !1))
                r.setStateMap(e, a)
                r.setAsyncMap(e, !1)
            })
            this.checkAsyncQue();
            n.dealOCR(e, a, t);
        }

    }
    checkAsyncQue = function () {
        var e = this
            , t = [];
        _.forEach(this.asyncTodoQue, function (n) {
            n.version < e.getVersion(n.widgetName, n.row) || t.push(n)
        })
        this.asyncTodoQue = t
    }
    finishRely = function (e, t, n) {
        if (e && e.rely) {
            var r = e.rely;
            r && r.filter && r.data && this.dequeueAsync(t, n)
        }
    }

    finishFormEvent = function (e, t) {
        this.isEventNode(e) && this.dequeueAsync(e, t)
    }

    checkEventAsyncVersion = function (e, t, n) {
        return this.getState(e, n) <= t
    }
    updateEventAsyncState = function (e, t, n) {
        var r = this;
        this.setAsyncMap(e, t, n);
        var a = this.getEventById(e);
        _.forEach(a.action, function (e) {
            if (e.field) {
                var a = Math.max(r.getState(e.field, n), t);
                r.setStateMap(e.field, a, n)
            }
        })
    }

    dequeueAsync = function (e, t) {
        var n = -1;
        var que = _.extend(this.asyncConcurrentQue)
        window.openRelylog && console.log('asyncConcurrentQue 1', e, t);
        window.openRelylog && console.log('asyncConcurrentQue 2', this.asyncConcurrentQue.length);
        _.forEach(que, function (r, a) {
            if (r.widgetName === e && r.row === t) {
                n = a;
                return !1
            }
        })
        if (n > -1) {
            this.updateAsyncQueen(null, n)
        }
        // n > -1 && this.updateAsyncQueen(null, n)
        if (this.asyncConcurrentQue.length < this.asyncLimit) {
            var r = this.asyncTodoQue.shift();
            if (!r) {
                window.openRelylog && console.log('asyncConcurrentQue 3', this.asyncConcurrentQue.length);
                return;
            }

            "event" === r.type ? this.startFormEvent(r.version, r.widgetName, r.form, r.row) : this.startRely(r.form, r.widgetName, r.widget, r.version, r.row)
        }
    }

    releaseAsyncQue = function (e) {
        var t, n = e.path;
        _.isNil(e.rowId) || (t = e.rowId);
        this.finishRely(e, n, t)
    }

    triggerEvent = function (e, t, n, r) {
        var a = this
            , i = this.getEventById(e)
            , o = t.getField(i.trigger, r);

        if (o) {
            if (!o.rely) {

                if (_.isObjectEmpty(o.value)) {
                    this.setStateMap(e, n, r);
                    this.setAsyncMap(e, n, r);
                    _.forEach(i.action, function (e) {
                        a.setStateMap(e.field, n, r);
                        var i = t.getField(e.field, r);
                        i && a.fireRely(i, n, t)
                    })
                } else {
                    this.fireFormEvent(n, e, t, r)
                }
            }
        }


        // o && (o.rely || (_.isObjectEmpty(o.value) ? (this.setStateMap(e, n, r),
        //     this.setAsyncMap(e, n, r),
        //     _.forEach(i.action, (function (e) {
        //         a.setStateMap(e.field, n, r);
        //         var i = t.getField(e.field, r);
        //         i && a.fireRely(i, n, t)
        //     }
        //     ))) : this.fireFormEvent(n, e, t, r)))
    }

    qf4 = (e) => {
        return "linkdata" === e
    }

    E = function (e) {
        return "lookup" === e
    }

    fireRowRely = function (e, t, n, r, a) {
        var i = this
            , o = !1
            , l = []
            , u = []
            , c = ++this.version
            , s = r.name;
        this.setVersionMap(s, c, n);
        this.setStateMap(s, c, n);
        this.setAsyncMap(s, c, n);
        let all = [...t, ...a];
        _.forEach(all, (function (e) {
            var t = e.path;
            _.merge(i.versionMap, i.getRelyVersion(i.linkMap, t, c, {}, !1, n));

            if (e.rely && !i.qf4(e.type)) {
                i.setVersionMap(t, c, n);
                l.push(e);
                o = !0
            }

            // e.rely && !i.qf4(e.type) && (i.setVersionMap(t, c, n),
            //     l.push(e),
            //     o = !0);
            _.forEach(i.linkMap[t], (function (e) {
                if (i.isEventNode(e)) {
                    u.push(e);
                    o = !0
                }

                // i.isEventNode(e) && (u.push(e), o = !0)
            }
            ))
        }
        ));
        _.forEach(a, (function (e) {
            var t = e.path;
            i.setExcludeMap(t, c, n)
        }
        ));
        var d = [];
        _.forEach(this.linkMap[s], (function (e) {
            var t = e;
            i.isEventNode(e) && (t = i.getEventById(e).trigger);

            if (!(_._isSubformWidget(t) && t.split(".")[0] === s)) {
                i.setVersionMap(e, c, n);
                _.merge(i.versionMap, i.getRelyVersion(i.linkMap, e, c, {}, !1, n));
                d.push(e);
            }

            // _._isSubformWidget(t) && t.split(".")[0] === s || (i.setVersionMap(e, c, n),
            //     _.merge(i.versionMap, i.getRelyVersion(i.linkMap, e, c, {}, !1, n)),
            //     d.push(e))
        }
        ));
        this.checkAsyncQue();

        if (o) {
            _.forEach(l, (function (t) {
                var r = t.path;
                if (i.checkRely(e, c, r, n)) {
                    i.setAsyncMap(r, !1, n);
                    i.startRely(e, r, t, c, n);
                }

                // i.checkRely(e, c, r, n) && (i.setAsyncMap(r, !1, n),
                //     i.startRely(e, r, t, c, n))
            }
            ))
            _.forEach(u, (function (t) {
                i.triggerEvent(t, e, c, n)
            }
            ))
        }

        // o && (_.forEach(l, (function (t) {
        //     var r = t.path;
        //     i.checkRely(e, c, r, n) && (i.setAsyncMap(r, !1, n),
        //         i.startRely(e, r, t, c, n))
        // }
        // )),
        //     _.forEach(u, (function (t) {
        //         i.triggerEvent(t, e, c, n)
        //     }
        //     )))
        _.forEach(d, (function (t) {
            if (i.isEventNode(t))
                i.triggerEvent(t, e, c, n);
            else {
                var r = e.getField(t);

                if (i.checkRely(e, c, t, n)) {
                    i.setAsyncMap(t, !1, n);
                    i.startRely(e, t, r, c, n);
                }

                // i.checkRely(e, c, t, n) && (i.setAsyncMap(t, !1, n),
                //     i.startRely(e, t, r, c, n))
            }
        }
        ))
    }

    batchRowRely = function (e, t, n) {
        var a = this
            , i = !1
            , o = {}
            , l = {}
            , u = ++this.version
            , c = t.name;
        _.forEach(n, (function (n) {
            a.setVersionMap(c, u, n);
            a.setStateMap(c, u, n);
            a.setAsyncMap(c, u, n);
            var s = []
                , d = [];
            _.forEach(t.items, (function (r) {
                var o = e.getField([t.name, r.widget.widgetName].join("."), n);
                if (o) {
                    var l = o.path;
                    _.merge(a.versionMap, a.getRelyVersion(a.linkMap, l, u, {}, !1, n));
                    if (o.rely && !a.qf4(o.type)) {
                        a.setVersionMap(l, u, n);
                        s.push(o);
                        i = !0;
                    }

                    // o.rely && !a.qf4(o.type) && (a.setVersionMap(l, u, n),
                    //     s.push(o),
                    //     i = !0);
                    _.forEach(a.linkMap[l], (function (e) {
                        if (a.isEventNode(e)) {
                            d.push(e);
                            i = !0;
                        }
                        // a.isEventNode(e) && (d.push(e),
                        //     i = !0)
                    }
                    ))
                }
            }
            ));
            _.merge(o, _.set({}, n, s));
            _.merge(l, _.set({}, n, d));
        }
        ));
        var s = [];
        _.forEach(this.linkMap[c], (function (e) {
            var t = e;
            a.isEventNode(e) && (t = a.getEventById(e).trigger);

            if (!(_._isSubformWidget(t) && t.split(".")[0] === c)) {
                a.setVersionMap(e, u);
                _.merge(a.versionMap, a.getRelyVersion(a.linkMap, e, u, {}, !1));
                s.push(e)
            }

            // _._isSubformWidget(t) && t.split(".")[0] === c || (a.setVersionMap(e, u),
            //     _.merge(a.versionMap, a.getRelyVersion(a.linkMap, e, u, {}, !1)),
            //     s.push(e))
        }
        ));
        this.checkAsyncQue();
        _.forEach(n, (function (t) {

            if (i) {
                _.forEach(_.get(o, t), (function (n) {
                    var r = n.path;
                    if (a.checkRely(e, u, r, t)) {
                        a.setAsyncMap(r, !1, t);
                        a.startRely(e, r, n, u, t);
                    }


                    // a.checkRely(e, u, r, t) && (a.setAsyncMap(r, !1, t),
                    //     a.startRely(e, r, n, u, t))
                }
                ));
                _.forEach(_.get(l, t), (function (n) {
                    a.triggerEvent(n, e, u, t)
                }
                ))
            }

            // i && (_.forEach(_.get(o, t), (function (n) {
            //     var r = n.path;
            //     if (a.checkRely(e, u, r, t)) {
            //         a.setAsyncMap(r, !1, t);
            //         a.startRely(e, r, n, u, t);
            //     }


            //     // a.checkRely(e, u, r, t) && (a.setAsyncMap(r, !1, t),
            //     //     a.startRely(e, r, n, u, t))
            // }
            // )),
            //     _.forEach(_.get(l, t), (function (n) {
            //         a.triggerEvent(n, e, u, t)
            //     }
            //     )))
        }
        ));
        _.forEach(s, (function (t) {
            if (a.isEventNode(t))
                a.triggerEvent(t, e, u);
            else {
                var n = e.getField(t);
                if (a.checkRely(e, u, t)) {
                    a.setAsyncMap(t, !1);
                    a.startRely(e, t, n, u);
                }

                // a.checkRely(e, u, t) && (a.setAsyncMap(t, !1),
                //     a.startRely(e, t, n, u))
            }
        }
        ))
    }


    fireRewrite = function (e, t) {
        var n = this;
        this.version++;
        var r = this.version;
        _.forEach(t, function (e) {
            n.setVersionMap(e.path, r, e.rowId);
            _.merge(n.versionMap, n.getRelyVersion(n.linkMap, e.path, r, {}, !1, e.rowId))
        })
        this.checkAsyncQue()
        _.forEach(t, function (t) {
            e.fireWidgetRelyEvent(t, r)
        })
    }

    startRely = function (e, t, n, r, a) {
        if (n) {
            var i = n.rely;
            if (i && i.filter && i.data) {
                var o = n.type
                    , l = n.widget.valueOption;
                if (_.includes(["combo", "combocheck"], o) || _.includes(["dept", "deptgroup"], o) && l === BsyConfig().WidgetValueOption.CUSTOM)
                    e.dealRely(n, r);
                else {
                    var u = {
                        form: e,
                        widgetName: t,
                        widget: n,
                        version: r,
                        row: a
                    };
                    // this.asyncConcurrentQue.length < this.asyncLimit ? (this.updateAsyncQueen(u)
                    //     e.dealRely(n, r)) : this.asyncTodoQue.push(u)
                    if (this.asyncConcurrentQue.length < this.asyncLimit) {
                        this.updateAsyncQueen(u);
                        e.dealRely(n, r);
                    } else {
                        this.asyncTodoQue.push(u)
                    }
                }
            } else
                e.dealRely(n, r)
        }
    }

    checkAsyncVersion = function (e, t) {
        return this.getVersion(e.path, e.rowId) <= t
    }

    isFieldRelyFinish = function (e, t) {
        var n = this.getVersion(e, t);
        if (!n)
            return !0;
        var r = this.getAsync(e, t);
        return n <= Number(r)
    }
    clearSubformRow = function (e, t) {
        var n = this
            , r = this.D(e, t);
        delete this.versionMap[r];
        delete this.stateMap[r];
        delete this.asyncMap[r];
        _.forEach(this.eventMap, function (r, e) {
            var a = n.D(r, t);
            delete n.versionMap[a];
            delete n.stateMap[a];
            delete n.asyncMap[a];
        })
    }

    updateAsyncQueen = function (e, t) {
        e ? this.asyncConcurrentQue.push(e) : this.asyncConcurrentQue.splice(t, 1)
    }
}
